import React, { useMemo } from 'react';
import { BackToTopButton as BackToTopButtonUI } from 'decentraland-ui/dist/components/BackToTopButton';
import { t } from '../../modules/translation/utils';
export const BackToTopButton = (props) => {
    const i18n = useMemo(() => ({
        title: t('@dapps.back_to_top_button.title')
    }), []);
    return React.createElement(BackToTopButtonUI, { i18n: i18n, ...props });
};
//# sourceMappingURL=BackToTopButton.js.map